import type { SxProps, Theme } from '@mui/material';

/** Shared homepage + manage-categories picker sizing (#206). */
export const CATEGORY_TILE_PX = 76;
export const CATEGORY_SUB_TILE_PX = 62;
export const CATEGORY_TILE_SLOT_PX = 80;
export const CATEGORY_SUB_TILE_SLOT_PX = 72;

/** Prevent native browser image-drag ghost while scrolling category rows. */
export const categoryTileImageSx: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
  userSelect: 'none',
  WebkitUserDrag: 'none',
  pointerEvents: 'none',
};
